module.exports = __webpack_public_path__ + "assets/CDoubleSeg.5e9581ae83be0c92b2ade83f561650a4.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CDoubleSeg.gmt
// module id = 905
// module chunks = 0